export default "__VITE_ASSET__CjCbDGPn__"